var map = {
	"./athlete-biography/athlete-biography.module.ngfactory": [
		"./src/app/athlete/athlete-biography/athlete-biography.module.ngfactory.js",
		0,
		1,
		2,
		3,
		7,
		30,
		31,
		40
	],
	"./athlete-matches/athlete-matches.module.ngfactory": [
		"./src/app/athlete/athlete-matches/athlete-matches.module.ngfactory.js",
		0,
		1,
		2,
		3,
		7,
		45
	],
	"./athlete-news/athlete-news.module.ngfactory": [
		"./src/app/athlete/athlete-news/athlete-news.module.ngfactory.js",
		0,
		1,
		2,
		5,
		7,
		12,
		"common",
		54
	],
	"./athlete-photos/athlete-photos.module.ngfactory": [
		"./src/app/athlete/athlete-photos/athlete-photos.module.ngfactory.js",
		0,
		1,
		2,
		7,
		16,
		28,
		50
	],
	"./athlete-records/athlete-records.module.ngfactory": [
		"./src/app/athlete/athlete-records/athlete-records.module.ngfactory.js",
		0,
		1,
		2,
		3,
		7,
		37
	],
	"./athlete-results/athlete-results.module.ngfactory": [
		"./src/app/athlete/athlete-results/athlete-results.module.ngfactory.js",
		0,
		1,
		2,
		3,
		7,
		13,
		38
	],
	"./athlete-statistics/athlete-statistics.module.ngfactory": [
		"./src/app/athlete/athlete-statistics/athlete-statistics.module.ngfactory.js",
		0,
		1,
		2,
		3,
		7,
		36
	],
	"./athlete/athlete.module.ngfactory": [
		"./src/app/athlete/athlete.module.ngfactory.js",
		1,
		2,
		4,
		5,
		7,
		6,
		8,
		11,
		62
	],
	"./coaches/coaches.module.ngfactory": [
		"./src/app/coaches/coaches.module.ngfactory.js",
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		9,
		48
	],
	"./members/details-page/details-page.module.ngfactory": [
		"./src/app/members/details-page/details-page.module.ngfactory.js",
		2,
		4,
		5,
		6,
		8,
		25,
		"common"
	],
	"./officials/officials.module.ngfactory": [
		"./src/app/officials/officials.module.ngfactory.js",
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		9,
		49
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;